export default "__VITE_ASSET__afebeddb__"